import { SafeHTML } from "@/utils/constants";
import Link from "next/link";

const Footer_Bottom = ({footerFifthSection}) =>{
    return(
        <div className="bg-black text-[#DBDBDB] font-normal">
        <div className="container">
          <div className="flex text-center flex-wrap justify-between items-center gap-y-2 py-2 lg:py-[1vw] text-[13px] lg:text-[0.9vw]">
            {/* <div className="flex-none w-full lg:w-auto" dangerouslySetInnerHTML={{__html:footerFifthSection?.copyright_text}}></div> */}
            
            <SafeHTML html={footerFifthSection?.copyright_text} className={"flex-none w-full lg:w-auto"} />
            
            <div className="flex-none w-full lg:w-auto ">
              <div className="flex items-center gap-x-1  justify-center text-black">

                <Link
                  href={footerFifthSection?.designer_company_website ?? ""}
                  target="_blank"
                >
                  <p>Kwebmaker</p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
}

export default Footer_Bottom;